import Switch from '@mui/material/Switch';
import { FormControlLabel, FormHelperText, Grid } from '@mui/material';
import { useController, UseControllerProps } from 'react-hook-form';
import { ReactNode, useState } from 'react';
import AppInformationText from '../../../app/components/AppInformationText';

interface Props extends UseControllerProps {
    name: string;
    label: string;
    information_text?: string | ReactNode;
    defaultValue?: boolean;
}

export default function AppPcsEventSwitchField(props: Props) {
    const { fieldState, field } = useController({ ...props, defaultValue: '' });
    const { label, name, information_text } = props;
    const [checked, setChecked] = useState(props.defaultValue);

    const handleChange = (event: any) => {
        setChecked(event.target.checked);
        field.onChange(event.target.checked);
    };

    return (
        <Grid container rowSpacing={4}>
            <Grid size={{ xs: 11 }}>
                <FormControlLabel label={label} control={
                    <Switch {...field} checked={checked} onChange={handleChange}
                        id={name} name={name} color={'success'} />
                } />
            </Grid>

            <Grid size={{ xs: 1 }}>
                <AppInformationText information_text={information_text} />
            </Grid>

            <Grid size={{ xs: 11, sm: 12 }}>
                {fieldState.error &&
                    <FormHelperText sx={{ color: 'primary.main' }}>{fieldState.error.message}</FormHelperText>}
            </Grid>
        </Grid>
    )
}
